import React, { useRef, useState } from 'react';
import TabOfDataTable from '../../../Elements/DataTable/TabOfDataTable';
import GeneralEditPanelBase from '../../../Elements/GeneralEditPanelBase';
import ErrorMessage from '../../../Elements/ErrorMessage';
import FigmaButtonRow from '../../../Elements/FigmaButtonRow';
import ButtonTypeEnum from '../../../Enums/ButtonTypeEnum';
import ButtonColorsEnum from '../../../Enums/ButtonColorsEnum';
import IconPositionEnum from '../../../Enums/IconPositionEnum';
import TpDataImportExcludedItem from '../../../Domain/TpDataImportExcludedItem';
import TpDataImportExcludedItemService from '../../../Services/TpDataImportExcludedItemService';
import TpDataImportExcludedItemSearchParams from './TpDataImportExcludedItemSearchParams';
import TpDataImportExcludedItemPanelDescription from './TpDataImportExcludedItemPanelDescription';

// Admin page for the third-party data-import exclusion list (test/admin evaluators that must not
// be imported from external systems). Server-side list/search, an add/edit panel (upsert) and a
// row delete action. Talks to the TpDataImportExcludedItem monolith controller, which delegates to
// the Tp_DataExport_Micro microservice.
const TpDataImportExcludedItemAdmin = () => {
  const [searchItem, setSearchItem] = useState<any>(() => new (TpDataImportExcludedItemSearchParams as any)());
  const [editedItem, setEditedItem] = useState<any>(null);
  // Ref to the table so a save/delete can refresh the CURRENT page instead of resetting to page 1.
  const tableRef = useRef<any>(null);

  const refreshTable = () => {
    if (tableRef.current) {
      tableRef.current.refresh();
    }
  };

  const deleteApprove = (id: any, item: any) => {
    ErrorMessage.SetApprove(
      <span>
        You are about to delete import excluded item #{id}
        <br />
        Pattern: {item.Pattern} ({item.PatternType})
        <br />
        Are you sure?
      </span>,
      () =>
        TpDataImportExcludedItemService.DeleteItem(id)
          .then(() => refreshTable())
          .catch(() => ErrorMessage.SetErrorMessage('TDIIA02'))
    );
  };

  // Row actions. The Third-Party Instance dropdown self-loads (TpInstanceSelect), so nothing extra
  // needs to be attached to the edited item here.
  const domain = TpDataImportExcludedItem as any;
  domain.editFunction = (id: any, item: any) => setEditedItem({ ...item });
  domain.deleteFunction = (id: any, item: any) => deleteApprove(id, item);

  const openCreatePanel = () => {
    setEditedItem(new (TpDataImportExcludedItem as any)());
  };

  const startSearch = (newSearchItem: any) => setSearchItem({ ...newSearchItem });

  const closeEditPanel = (refresh: any) => {
    setEditedItem(null);
    // GeneralEditPanelBase calls onClose(true) on a successful save.
    if (refresh === true) {
      refreshTable();
    }
  };

  return (
    <div className='contentwrapper'>
      <FigmaButtonRow
        buttons={
          [
            {
              iconName: 'fa-solid fa-plus-circle',
              type: ButtonTypeEnum.NormalIconOnly,
              color: ButtonColorsEnum.Common,
              iconPosition: IconPositionEnum.Center,
              onClick: openCreatePanel,
              tooltip: 'Create',
            },
          ] as any
        }
      />
      {editedItem && (
        <GeneralEditPanelBase
          popup={true}
          editedItem={editedItem}
          panelDescription={TpDataImportExcludedItemPanelDescription}
          onClose={closeEditPanel}
          maxWidth={900}
          errorCode='TDIIA03'
        />
      )}
      <TabOfDataTable
        ref={tableRef}
        type={TpDataImportExcludedItem}
        serviceFunction={TpDataImportExcludedItemService.GetAllItemBySearching}
        convertDBItemsFunction={TpDataImportExcludedItemService.ConvertDBItems}
        searchItem={searchItem}
        searchParamsType={TpDataImportExcludedItemSearchParams}
        showSearchStrip={true}
        clickOnStartSearch={startSearch}
        popupEnabled={true}
        singleSearchLine={true}
        singleSearchLinePlaceholder='Search in pattern, type, reason...'
        errorCode='TDIIA04'
      />
    </div>
  );
};

export default TpDataImportExcludedItemAdmin;
